import { Link } from '@tanstack/react-router';
import { ArrowLeft, Flame, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface AdminScript {
  id: string;
  name: string;
  desc: string;
  to: string;
  icon: typeof Flame;
  tags: string[];
}

const SCRIPTS: AdminScript[] = [
  {
    id: 'radar-ipize',
    name: '热点抓取与 IP 化',
    desc: '多平台热搜抓取 → 政策清洗 → LLM 打标 → Top 12 自动 IP 化',
    to: '/admin/scripts/radar-ipize',
    icon: Flame,
    tags: ['B站', '微博', '知乎', '百度', '头条', '抖音'],
  },
];

export function AdminScriptsPage() {
  return (
    <div className="space-y-6 p-6 lg:p-8">
      <header>
        <Link
          to="/admin"
          className="inline-flex items-center gap-1 text-xs text-neutral-500 hover:text-brand-500"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          返回管理员
        </Link>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight">脚本采集</h1>
        <p className="mt-1 text-sm text-neutral-600">
          统一管理所有定时执行的爬虫脚本 · 后续接入新脚本(如评论抓取、行业资讯)只需在此追加
        </p>
      </header>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SCRIPTS.map((s) => {
          const Icon = s.icon;
          return (
            <Link key={s.id} to={s.to} className="block">
              <Card className="group h-full cursor-pointer">
                <CardContent className="flex h-full flex-col gap-3 p-5">
                  <div className="flex items-start justify-between">
                    <span
                      className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-white"
                      style={{ backgroundColor: '#FFB400' }}
                    >
                      <Icon className="h-5 w-5" />
                    </span>
                    <ChevronRight className="h-4 w-4 text-neutral-400 transition-transform group-hover:translate-x-0.5 group-hover:text-brand-500" />
                  </div>
                  <div>
                    <div className="text-base font-semibold text-neutral-900">{s.name}</div>
                    <p className="mt-1 text-xs leading-relaxed text-neutral-500">{s.desc}</p>
                  </div>
                  <div className="mt-auto flex flex-wrap gap-1">
                    {s.tags.map((t) => (
                      <span
                        key={t}
                        className="rounded-full bg-surface-variant px-2 py-0.5 text-[10px] text-neutral-600"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
